var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charge"},[_c('div',{staticClass:"main-left"},[_vm._v(" 收费管理 ")]),_c('div',{staticClass:"main-right"})])
}]

export { render, staticRenderFns }